import { createSlice } from "@reduxjs/toolkit";

const devAuthSlice = createSlice({
  name: "devAuth",
  initialState: {
    developer_token: localStorage.getItem("developer_token") || "",
    dev_partner_id: localStorage.getItem("dev_partner_id") || "",
    dev_refresh_token: localStorage.getItem("dev_refresh_token") || "",
    dev_email_verified: localStorage.getItem("dev_email_verified") || "",
    developer_id: localStorage.getItem("developer_id") || "",
    dev_first_name: localStorage.getItem("dev_first_name") || "",
    dev_last_name: localStorage.getItem("dev_last_name") || "",
    dev_email: localStorage.getItem("dev_email") || "",
  },
  reducers: {
    devloggedIn: (state, action) => {
      const {
        developer_token,
        dev_partner_id,
        dev_refresh_token,
        dev_email_verified,
        developer_id,
        dev_first_name,
        dev_email,
        dev_last_name,
      } = action.payload;
      state.developer_token = developer_token;
      state.dev_partner_id = dev_partner_id;
      state.dev_refresh_token = dev_refresh_token;
      state.dev_email_verified = dev_email_verified;
      state.developer_id = developer_id;
      state.dev_first_name = dev_first_name;
      state.dev_last_name = dev_last_name;
      state.dev_email = dev_email;

      // Save authentication data to local storage
      setUserAuth(action.payload);
    },
    devloggedOut: (state) => {
      // Clear authentication data from state
      state.developer_token = "";
      state.dev_partner_id = "";
      state.dev_refresh_token = "";
      state.dev_email_verified = "";
      state.developer_id = "";
      // Clear authentication data from local storage
      removeUserAuth();
    },
  },
});

const setUserAuth = (payload: IUserAuth) => {
  localStorage.setItem("developer_token", payload.developer_token);
  localStorage.setItem("dev_partner_id", payload.dev_partner_id || "");
  localStorage.setItem("dev_refresh_token", payload.dev_refresh_token || "");
  localStorage.setItem("dev_email_verified", payload.dev_email_verified || "");
  localStorage.setItem("developer_id", payload.developer_id);
  localStorage.setItem("dev_first_name", payload.dev_first_name);
  localStorage.setItem("dev_last_name", payload.dev_last_name);
  localStorage.setItem("dev_email", payload.dev_email);
};

const removeUserAuth = () => {
  localStorage.clear();
};

export const { devloggedIn, devloggedOut } = devAuthSlice.actions;
export default devAuthSlice.reducer;

export interface IUserAuth {
  developer_token: string;
  dev_partner_id?: string;
  dev_refresh_token?: string;
  dev_email_verified?: string;
  developer_id: string;
  dev_first_name: string;
  dev_last_name: string;
  dev_email: string;
}
